import ICONS from "../../../../../assets/Icons";
import SVGComponent from "../../../../_utils/SVGComponent";
import DataActionField from "../../../../_utils/TransactionCommonComponents/DataActionField";

const InternalRecreateTxnStepAdditionalDetails = ({
  refactorTransactionData,
  txnPayLoad,
  initialRefactorAdditionalDetail,
  setInitialRefactorAdditionalDetail,
  setAutoFill,
  onCopyLabels,
  displayLabels,
  prevLabels,
  labelsCopied,
  handlePreviousTransactionClick,
}) => {
  return (
    <main className="flex flex-col lg:flex-row gap-gap-md bg-primary-bg Qsmd:bg-primary-card h-screen lg:h-full w-width-full fixed Qsmd:z-z-index-content z-z-index-header Qsmd:relative top-top-base left-left-base mt-margin-base Qsmd:h-full">
      <div className="h-mobile-create-header flex w-width-full bg-primary-nav Qsmd:hidden">
        <div className="p-padding-md Qsmd:p-padding-base">
          <div
            className="flex flex-shrink-0 cursor-pointer"
            onClick={() => {
              setAutoFill(false);
            }}
          >
            <SVGComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color="var(--text-primary)"
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
              alt="Arrow right"
            />
          </div>
        </div>
        <div className="flex flex-col w-width-full py-padding-sm">
          <div className="text-text-primary text-font-md">
            Create transaction
          </div>
          <p className=" text-text-primary text-xs font-semibold">
            Previous transaction details
          </p>
        </div>
      </div>
      <div className="h-full lg:flex-1 Qsmd:max-h-half-screen-height flex flex-col lg:flex-row gap-gap-md lg:gap-gap-base overflow-y-auto">
        <section className="w-width-full lg:w-width-md flex flex-col gap-gap-sm pl-padding-md Qsmd:pl-padding-base pr-padding-md lg:pr-padding-lg Qsmd:mt-margin-md">
          <p className="text-font-md font-semibold text-text-primary whitespace-nowrap mb-margin-sm">
            Additional Details
          </p>

          {refactorTransactionData?.additional_data?.data?.filter(
            (data) => data?.data_type !== "upload",
          )?.length ? (
            refactorTransactionData?.additional_data?.data
              ?.filter((data) => data?.data_type !== "upload")
              ?.map((details, index) => {
                const hasData =
                  details?.value !== null &&
                  details?.value !== undefined &&
                  !(
                    typeof details?.value === "string" &&
                    details.value.trim() === ""
                  ) &&
                  !(
                    Array.isArray(details?.value) && details.value.length === 0
                  ) &&
                  !(
                    typeof details?.value === "object" &&
                    !Array.isArray(details.value) &&
                    Object.values(details.value || {}).every(
                      (v) => v === null || v === undefined || v === "",
                    )
                  );

                const isSimpleType =
                  details?.data_type === "hyperlink" ||
                  details?.data_type === "string" ||
                  details?.data_type === "numeric";

                const displayValue = !hasData
                  ? "No Data"
                  : typeof details?.value === "boolean"
                    ? JSON.stringify(details?.value)
                    : typeof details?.value === "object"
                      ? details?.data_type === "from_year_to_year"
                        ? `${details?.value?.from} / ${details?.value?.to}`
                        : details?.data_type === "date_range"
                          ? `${details?.value?.start_date} - ${details?.value?.end_date}`
                          : details?.value?.map(
                              (val, i) =>
                                `${val}${details?.value?.length - 1 === i ? "" : ", "}`,
                            )
                      : details?.value === undefined
                        ? "No Data"
                        : details?.value;

                const isCopied =
                  initialRefactorAdditionalDetail?.[details?.name]
                    ?.isCopySource;

                const icon = isSimpleType
                  ? isCopied
                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                    : ICONS?.COPY
                  : isCopied
                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                    : ICONS?.AUTOFILL_WHITE;

                const hoverEnabled =
                  icon === ICONS?.COPY || icon === ICONS?.AUTOFILL_WHITE;

                return (
                  <div
                    key={`${index}-additional-data`}
                    className={`w-full flex flex-col gap-gap-xs ${refactorTransactionData?.category !== txnPayLoad?.selectedCategory?.name ? "opacity-base-opacity" : "opacity-light-opacity"}`}
                  >
                    <DataActionField
                      subLabel={details?.name}
                      value={displayValue}
                      icon={icon}
                      hoverEnabled={hoverEnabled}
                      disabled={!hasData}
                      onClick={() => handlePreviousTransactionClick(details)}
                    />
                  </div>
                );
              })
          ) : (
            <div className="text-left text-text-primary text-sm">
              Additional details are not supported for the selected category.
            </div>
          )}
          <div className="invisible hidden lg:flex">Don't remove this div</div>
        </section>
        <div className="w-width-full lg:w-width-md lg:mt-margin-md pl-padding-md Qsmd:pl-padding-base pr-padding-md mb-margin-md lg:mb-margin-base lg:pl-padding-sm">
          <p className="text-font-md font-semibold text-text-primary whitespace-nowrap mb-margin-md">
            Labels (Optional)
          </p>
          <div
            className={`w-full flex flex-col gap-gap-xs ${prevLabels.length ? "opacity-base-opacity" : "opacity-light-opacity"}`}
          >
            <DataActionField
              value={displayLabels}
              icon={
                labelsCopied
                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS?.AUTOFILL_WHITE
              }
              hoverEnabled={!labelsCopied}
              disabled={!prevLabels.length}
              onClick={() => {
                if (!prevLabels.length) return;
                setInitialRefactorAdditionalDetail((prev) => ({
                  ...prev,
                  __labels__: {
                    ...prev.__labels__,
                    isCopyDirect: true,
                    data: prevLabels,
                  },
                }));
                onCopyLabels(prevLabels);
              }}
            />
          </div>
          <div className="invisible hidden lg:flex leading-[var(--icon-xs)]">
            Don't remove this div
          </div>
        </div>
      </div>
    </main>
  );
};

export default InternalRecreateTxnStepAdditionalDetails;
